import { AccessToken } from '~/Api/Authentication';
import { Action as ImpersonateAction, ActionType as ImpersonateActionType } from '~/UserImpersonate';

import { Action, ActionType } from './Action';

export interface State {
	request: Promise<{ accessToken: AccessToken }> | null;
	isFetching: boolean;
	accessToken: AccessToken | null;
}

function createState(): State {
	return {
		request: null,
		isFetching: false,
		accessToken: null,
	};
}

export default function reducer(state: State = createState(), action: Action | ImpersonateAction): State {
	switch (action.type) {
		case ActionType.requestLogin:
		case ActionType.request:
		case ImpersonateActionType.request:
		case ImpersonateActionType.requestSwitchBack:
			return { ...state, request: action.request, isFetching: true };

		case ActionType.receive:
		case ActionType.receiveLogin:
		case ImpersonateActionType.receive:
		case ImpersonateActionType.receiveSwitchBack:
			if (state.request !== action.request) {
				return state;
			}
			if (action.accessToken === null) {
				return {
					...state,
					request: null,
					isFetching: false,
					accessToken: null,
				};
			}
			return { ...state, isFetching: false, accessToken: action.accessToken };

		case ActionType.logout:
			return createState();

		default:
			return state;
	}
}

export function selectUserId(state: State): string | null {
	return state.accessToken?.user.id ?? null;
}
